import $ from 'jquery';
import _ from "underscore";
import collectDataAttributesFor from "../collectDataAttributesFor";
import "./quickExpander.less";
// data attributes:
// q-expander-closest
// q-expander-open-icon
// q-expander-close-icon
const wind$ = window.$;

$(()=>{
  $(document).on("click", ".q-expander, .quick-expander", function(e){
    e.preventDefault();
    const el = $(this);
    quickExpander(el);
  });


  function quickExpander(el){
    const rawEl = el.get(0);
    // Note:
    // Code Smell Ref 1: in order to accommodate
    // ricochet window jQuery communication
    // and bundle jQuery.
    // once we are on the same build process
    // and remove old window jQuery bindings,
    // we can remove this
    const windEl = wind$(rawEl);

    const options = collectDataAttributesFor(rawEl, {prefix: "q-expander"});

    const $iconTarget = $(el).find('.fa');
    
    let target = $();

    if(options.closest){
      target = el.closest(options.closest).find(options.target);
    }
    else{
      target = $(options.target);
    }



    if(isOpen(target)){
      quickExpanderCloseAll(target);
      $iconTarget.removeClass(options.closeIcon).addClass(options.openIcon);
      handleTrigger("quickExpander:expander:onClose");
      
    }else{
      quickExpanderOpenAll(target);
      $iconTarget.removeClass(options.openIcon).addClass(options.closeIcon);
      handleTrigger("quickExpander:expander:onOpen");
    }


    function handleTrigger(str){
      // Code Smell Ref 1
      windEl.trigger(str);
      el.trigger(str);
    }


    function quickExpanderCloseAll(target){
      target.each(function(){
        quickExpanderCloseTarget($(this));
      });
    }

    function quickExpanderOpenAll(target){
      target.each(function(){
        quickExpanderOpenTarget($(this));
      });
    }

    function quickExpanderCloseTarget(target){
      target.removeClass("q-expandee-open");
      target.animate({
        height: 0
      }, 200);
    }    

    function quickExpanderOpenTarget(target){
      target.addClass("q-expandee-open");
      target.css({height: "auto"});
      const h = target.height();
      target.css({height: 0});

      target.animate({
        height: `${h}px`
      }, 200, function(){
        target.css({height: "auto"});
      });
    }




    function isOpen(target){
      return _(target.toArray()).any((curEl)=>{
        curEl = $(curEl);
        return curEl.hasClass('q-expandee-open');
      })
    }
  }
});

// import "./quickExpanderTest";



// WEBPACK FOOTER //
// ./src/utilities/quickExpander/index.js